import React from "react";
import { Link } from "react-router-dom";
import style from "./footer.scss";
import data from "../../page/Home/data.json";

const Footer = () => {
  const footer_top_dt = data.FOOTER.TOP;
  const footer_bottom_dt = data.FOOTER.BOTTOM.MEDIA;
  const topFooter = () => {
    return (
      <div className={style["contentinfo"]}>
        <div className={style["module-box"]}>
          {Object.entries(footer_top_dt).map(([key, data]) => {
            return (
              <div key={key} className={style["subfooter-links"]}>
                <small className={style["subfooter-label"]}>{key}</small>
                <ul>
                  {Object.entries(data).map(([_key, _data]) => {
                    return (
                      <li key={_key}>
                        <Link to={_data} target="_blank">
                          <small>{_key}</small>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const bottomFooter = () => {
    return (
      <div className={style["contentinfo"]}>
        <div className={style["module-box-bottom"]}>
          <small> © Madhur Gupta</small>
          <ul>
            {Object.entries(footer_bottom_dt).map(([key, data]) => {
              return (
                <li key={key}>
                  <a href={data} target="_blank" rel="noopener noreferrer">
                    {renderSVG(key)}
                  </a>
                </li>
              );
            })}
          </ul>
          <ul>
            <li>
              <Link to={"mailTo:guptamadhur96@gmail.com"} target="_blank">
                {/* TODO Chat Form */}
                <small>Contact Me</small>
              </Link>
            </li>
            <li>
              <Link to={"/privacy"}>
                <small>Privacy &amp; Terms</small>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  const renderSVG = (key) => {
    switch (key) {
      case "Twitter":
        return (
          <svg width="30px" height="30px" viewBox="0 0 49.652 49.652">
            <path d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zm11.075 19.144c.011.246.017.494.017.742 0 7.551-5.746 16.255-16.259 16.255-3.227 0-6.231-.943-8.759-2.565.447.053.902.08 1.363.08 2.678 0 5.141-.914 7.097-2.446a5.72 5.72 0 01-5.338-3.969 5.76 5.76 0 002.58-.096 5.715 5.715 0 01-4.583-5.603l.001-.072a5.69 5.69 0 002.587.714 5.71 5.71 0 01-2.541-4.755c0-1.048.281-2.03.773-2.874a16.225 16.225 0 0011.777 5.972 5.707 5.707 0 01-.147-1.303 5.714 5.714 0 019.884-3.91 11.406 11.406 0 003.63-1.387 5.74 5.74 0 01-2.516 3.162 11.36 11.36 0 003.282-.899 11.494 11.494 0 01-2.848 2.954z"></path>
          </svg>
        );
      case "Github":
        return (
          <svg height="30px" viewBox="0 0 438.549 438.549" width="30px">
            <path d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417a2549.81 2549.81 0 01-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289s4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136s11.704-.476 16.274-1.423c4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"></path>
          </svg>
        );
      case "LinkedIn":
        return (
          <svg viewBox="0 0 310 310" height="30px" width="30px">
            <path d="M72.16 99.73H9.927a5 5 0 00-5 5v199.928a5 5 0 005 5H72.16a5 5 0 005-5V104.73a5 5 0 00-5-5zM41.066.341C18.422.341 0 18.743 0 41.362 0 63.991 18.422 82.4 41.066 82.4c22.626 0 41.033-18.41 41.033-41.038C82.1 18.743 63.692.341 41.066.341zM230.454 94.761c-24.995 0-43.472 10.745-54.679 22.954V104.73a5 5 0 00-5-5h-59.599a5 5 0 00-5 5v199.928a5 5 0 005 5h62.097a5 5 0 005-5V205.74c0-33.333 9.054-46.319 32.29-46.319 25.306 0 27.317 20.818 27.317 48.034v97.204a5 5 0 005 5H305a5 5 0 005-5V194.995c0-49.565-9.451-100.234-79.546-100.234z"></path>
          </svg>
        );
      case "Instagram":
        return (
          <svg width="30px" height="30px" viewBox="0 0 49.652 49.652">
            <path d="M24.825 29.796a4.978 4.978 0 004.972-4.97 4.954 4.954 0 00-.94-2.897 4.964 4.964 0 00-4.029-2.073c-1.659 0-3.126.82-4.031 2.072a4.947 4.947 0 00-.94 2.897 4.973 4.973 0 004.968 4.971zM35.678 18.746V13.96l-.623.002-4.164.013.016 4.787z"></path>
            <path d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zm14.119 21.929v11.56a5.463 5.463 0 01-5.457 5.458H16.164a5.462 5.462 0 01-5.457-5.458V16.165a5.462 5.462 0 015.457-5.457h17.323a5.463 5.463 0 015.458 5.457v5.764z"></path>
            <path d="M32.549 24.826c0 4.257-3.464 7.723-7.723 7.723s-7.722-3.466-7.722-7.723a7.67 7.67 0 01.568-2.897h-4.215v11.56a2.706 2.706 0 002.706 2.704h17.323a2.707 2.707 0 002.706-2.704v-11.56h-4.217c.367.894.574 1.873.574 2.897z"></path>
          </svg>
        );
      case "GmailID":
        return (
          <svg viewBox="0 0 512 512" height="30px" width="30px">
            <path d="M507.49 101.721L352.211 256 507.49 410.279c2.807-5.867 4.51-12.353 4.51-19.279V121c0-6.927-1.703-13.412-4.51-19.279zM467 76H45c-6.927 0-13.412 1.703-19.279 4.51l198.463 197.463c17.548 17.548 46.084 17.548 63.632 0L486.279 80.51C480.412 77.703 473.927 76 467 76zM4.51 101.721C1.703 107.588 0 114.073 0 121v270c0 6.927 1.703 13.413 4.51 19.279L159.789 256 4.51 101.721z"></path>
            <path d="M331 277.211l-21.973 21.973c-29.239 29.239-76.816 29.239-106.055 0L181 277.211 25.721 431.49C31.588 434.297 38.073 436 45 436h422c6.927 0 13.412-1.703 19.279-4.51L331 277.211z"></path>
          </svg>
        );
      case "Facebook":
        return (
          <svg width="30px" height="30px" viewBox="0 0 96.124 96.123">
            <path d="M72.089.02L59.624 0C45.62 0 36.57 9.285 36.57 23.656v10.907H24.037a1.96 1.96 0 00-1.96 1.961v15.803a1.96 1.96 0 001.96 1.96H36.57v39.876a1.96 1.96 0 001.96 1.96h16.352a1.96 1.96 0 001.96-1.96V54.287h14.654a1.96 1.96 0 001.96-1.96l.006-15.803a1.963 1.963 0 00-1.961-1.961H56.842v-9.246c0-4.444 1.059-6.7 6.848-6.7l8.397-.003a1.96 1.96 0 001.959-1.96V1.98A1.96 1.96 0 0072.089.02z"></path>
          </svg>
        );
      default:
        return "";
    }
  };
  return (
    <div className={style["footer"]}>
      {topFooter()}
      {bottomFooter()}
    </div>
  );
};

export default Footer;
